document.addEventListener('DOMContentLoaded', function () {
  const form = document.getElementById('address_form_new');
  if (!form) return;

  const submitBtn = form.querySelector('button[type="submit"], .button');

  const fields = [
    { id: 'AddressCountryNewcountry', regex: /^[A-Za-z\s]+$/, msg: 'Enter a valid country (letters only).' },
    { id: 'AddressAddress1New', regex: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z0-9\s,.-]+$/, msg: 'Street must include both letters and numbers.' },
    { id: 'AddressCityNew', regex: /^[A-Za-z\s]+$/, msg: 'Enter a valid city (letters only).' }
  ];

  function showError(field, message) {
    const errorSpan = field.parentElement.querySelector('.error-msg');
    if (errorSpan) {
      errorSpan.textContent = message;
      errorSpan.style.color = 'red';
      errorSpan.style.fontSize = '12px';
    }
    field.classList.add('invalid');
  }

  function clearError(field) {
    const errorSpan = field.parentElement.querySelector('.error-msg');
    if (errorSpan) {
      errorSpan.textContent = '';
    }
    field.classList.remove('invalid');
  }

  function validateField(field, regex, message) {
    const value = field.value.trim();
    if (value === '') {
      clearError(field); // Let required="" handle empty fields
      return false;
    }
    if (!regex.test(value)) {
      showError(field, message);
      return false;
    } else {
      clearError(field);
      return true;
    }
  }

  function validateAll() {
    let allValid = true;
    fields.forEach(({ id, regex, msg }) => {
      const field = document.getElementById(id);
      if (!field) return;
      const valid = validateField(field, regex, msg);
      if (!valid) allValid = false;
    });
    submitBtn.disabled = !allValid;
    submitBtn.classList.toggle('disabled-btn', !allValid);
  }

  fields.forEach(({ id, regex, msg }) => {
    const field = document.getElementById(id);
    if (field) {
      field.addEventListener('input', () => {
        validateField(field, regex, msg);
        validateAll();
      });
      field.addEventListener('blur', () => {
        validateField(field, regex, msg);
        validateAll();
      });
    }
  });

  form.addEventListener('submit', function (e) {
    validateAll();
    if (submitBtn.disabled) {
      e.preventDefault();
    }
  });
});
document.querySelectorAll('.form-field .show-password').forEach(function (toggleBtn) {
  toggleBtn.addEventListener('click', function () {
    const formField = toggleBtn.closest('.form-field');
    const passwordInput = formField.querySelector('input[type="password"], input[type="text"]');

    if (passwordInput) {
      const isPassword = passwordInput.type === 'password';
      passwordInput.type = isPassword ? 'text' : 'password';
      formField.classList.toggle('show-pass', isPassword);
    }
  });
});

var login_form = document.querySelector('.login-form');
var recover_form =  document.querySelector('.recover-form');
if(login_form &&  recover_form){
  document.querySelector('.enable-login').addEventListener('click',function(e){
    e.preventDefault();
    login_form.classList.remove('hide-form');
    recover_form.classList.add('hide-form');
  });
  document.querySelector('.enable-forgot').addEventListener('click',function(e){
    e.preventDefault();
    login_form.classList.add('hide-form');
    recover_form.classList.remove('hide-form');
  });
}
document.querySelectorAll('.edit-address-button').forEach(function(editbutton){
  editbutton.addEventListener('click',function(e){
    e.preventDefault();
    var address_id = this.dataset.addressid;
    document.querySelectorAll('.address-edit-form').forEach(function(editformdiv){
      if(editformdiv.classList.contains('active-form') && editformdiv.dataset.id != address_id){
        editformdiv.classList.remove('active-form');
      }
    });
    document.querySelector('[data-id="'+address_id+'"]').classList.toggle('active-form');
  });
});
if(document.querySelector('#AddressCountryNew')){
  new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
    hideElement: 'AddressProvinceContainerNew'
  });
  document.querySelectorAll('[data-address-country-select]').forEach((select) => {
    const formId = select.dataset.formId;
    new Shopify.CountryProvinceSelector(`AddressCountry_${formId}`, `AddressProvince_${formId}`, {
      hideElement: `AddressProvinceContainer_${formId}`
    });
  });
}
function handleDestroyClick(e) {
  e.preventDefault();

  const destroyId = this.dataset.destroy;
  console.log(destroyId);

  fetch('/account/addresses/' + destroyId, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest',
      'X-CSRF-Token': document.querySelector('meta[name=csrf-token]')?.content || ''
    },
    body: new URLSearchParams({ _method: 'delete' })
  })
  .then(response => {
    if (response.ok) {
      const url = window.location.href;
      fetch(url)
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');

          if (doc.querySelector('.address-part') && document.querySelector('.address-part')) {
            document.querySelector('.address-part').innerHTML = doc.querySelector('.address-part').innerHTML;
          }
          if (doc.querySelector('.address-wrapper') && document.querySelector('.address-wrapper')) {
            document.querySelector('.address-wrapper').innerHTML = doc.querySelector('.address-wrapper').innerHTML;
          }

          bindAddressEvents();
        })
        .catch(error => {
          console.error('Error fetching updated HTML:', error);
        });
    }
  })
  .catch(error => {
    console.error('Error during address delete:', error);
  });
}

function openNewAddressForm() {
  const addressForm = document.querySelector('#address_form_new');
  const addBtn = document.querySelector('.add-address');
  const nonAddress = document.querySelector('.non-address');

  if (addressForm) {
    addressForm.classList.add('active-open-form');
  }

  if (addBtn) {
    addBtn.style.display = 'none';
  }

  if (nonAddress) {
    nonAddress.style.display = 'none';
  }
}

function bindAddressEvents() {
  document.querySelectorAll('.destroy_button').forEach(button => {
    button.removeEventListener('click', handleDestroyClick);
    button.addEventListener('click', handleDestroyClick);
  });

  const addButton = document.querySelector('.add-address');
  if (addButton) {
    addButton.removeEventListener('click', openNewAddressForm);
    addButton.addEventListener('click', openNewAddressForm);
  }

  document.querySelector('.add-address-new')?.addEventListener('click', function () {
    const targetTab = document.querySelector('.tab[data-index="3"]');
    if (targetTab) {
      targetTab.click();

      setTimeout(() => {
        const addAddressBtn = document.querySelector('.add-address');
        if (addAddressBtn) addAddressBtn.click();
      }, 50);
    }
  });
}

document.addEventListener('DOMContentLoaded', function () {
  bindAddressEvents();
});
if(document.querySelector('.account-link')){
  document.querySelector('.account-link').addEventListener('click',function(e){
    document.querySelector('.account-page-active').classList.add('active');
    document.querySelector('.account-left').style.display = 'none';
  });
}